import { createColorParam, type ColorPalette } from '@paint-ai/shared';

export const PRESET_PALETTES: ColorPalette[] = [
  {
    id: 'modern-ivory-slate',
    name: 'Modern Ivory & Slate Charcoal',
    region: 'Pan-Indian Contemporary',
    description:
      'Crisp ivory walls paired with deep slate borders and warm wooden teak highlights. Ideal for modern duplexes.',
    wall: createColorParam('Ivory Silk', '#F5F2EB', '0912'),
    border: createColorParam('Slate Graphite', '#3A404A', '8290'),
    highlight: createColorParam('Warm Teak Wood', '#8C5A3C', 'WT-01'),
    asianPaintsCodes: {
      wall: 'Asian Paints Apex 0912 Ivory Frost',
      border: 'Asian Paints Apex 8290 Dark Charcoal',
      highlight: 'Asian Paints WoodTech Teak Polish',
    },
  },
  {
    id: 'rajasthani-sandstone',
    name: 'Jaipur Sandstone & Terracotta',
    region: 'North-West Heritage',
    description: 'Warm sandstone primary body with rich terracotta trim and antique brass highlight accents.',
    wall: createColorParam('Jaipur Sandstone', '#E8C59C', '4120'),
    border: createColorParam('Royal Terracotta', '#A84E32', '0482'),
    highlight: createColorParam('Antique Brass Gold', '#D4AF37', 'ME-03'),
    asianPaintsCodes: {
      wall: 'Asian Paints Apex 4120 Warm Sand',
      border: 'Asian Paints Apex 0482 Terracotta Red',
      highlight: 'Asian Paints Metal Enamel Gold Accent',
    },
  },
  {
    id: 'south-chettinad',
    name: 'South Indian Chettinad Mansion',
    region: 'Tamil Nadu & Kerala',
    description:
      'Classic off-white walls with vibrant indigo/cyan borders and deep maroon trims, traditional to Chettinad architecture.',
    wall: createColorParam('Eggshell Cream', '#F2EBD9', '0314'),
    border: createColorParam('Chettinad Teal Blue', '#1A6B7C', '7412'),
    highlight: createColorParam('Heritage Maroon', '#7A2222', '0418'),
    asianPaintsCodes: {
      wall: 'Asian Paints Apex 0314 Morning Mist',
      border: 'Asian Paints Apex 7412 Peacock Blue',
      highlight: 'Asian Paints Apex 0418 Crimson Red',
    },
  },
  {
    id: 'goan-latitud-coastal',
    name: 'Konkan Coastal White & Aqua',
    region: 'Goa & Konkan Coast',
    description:
      'Pristine bright white exterior with refreshing aqua borders and cobalt blue feature panels designed for coastal sunlight.',
    wall: createColorParam('Pure Coastal White', '#FAFAFA', '0001'),
    border: createColorParam('Seafoam Cyan', '#3E9B9A', '7320'),
    highlight: createColorParam('Cobalt Accent', '#1B4980', '7215'),
    asianPaintsCodes: {
      wall: 'Asian Paints Ultima Protek Pure White 0001',
      border: 'Asian Paints Apex 7320 Lagoon Blue',
      highlight: 'Asian Paints Apex 7215 Deep Royal',
    },
  },
  {
    id: 'bengaluru-minimalist',
    name: 'Bengaluru Tech Villa Gray',
    region: 'South Indian Modern',
    description: 'Minimalist warm gray base with matte black architectural window frames and terracotta louvers.',
    wall: createColorParam('Urban Ash Gray', '#D3D6D6', '8240'),
    border: createColorParam('Matte Jet Black', '#22252A', '8300'),
    highlight: createColorParam('Rust Cedar Accent', '#A0522D', 'RC-05'),
    asianPaintsCodes: {
      wall: 'Asian Paints Apex 8240 Platinum Gray',
      border: 'Asian Paints Apex 8300 Midnight Black',
      highlight: 'Asian Paints WoodTech Cedar',
    },
  },
  {
    id: 'himalayan-cedar-cream',
    name: 'Himalayan Cedar & Cream',
    region: 'North Indian Hill Architecture',
    description: 'Warm cream masonry with dark forest green roof eaves and pine wood timber accents.',
    wall: createColorParam('Alpine Cream', '#F7F3E8', '0320'),
    border: createColorParam('Forest Pine Green', '#2D4A3E', '7610'),
    highlight: createColorParam('Rich Chestnut', '#5C3317', 'WT-09'),
    asianPaintsCodes: {
      wall: 'Asian Paints Apex 0320 Soft Butter',
      border: 'Asian Paints Apex 7610 Cypress Green',
      highlight: 'Asian Paints WoodTech Chestnut Brown',
    },
  },
];
